import React, { useCallback, useEffect, useState } from 'react';
import './index.scss';

import Input from '../Input';
import Button from '../Button';

import ReCAPTCHA from 'react-google-recaptcha';

const { REACT_APP_RECAPTCHA_KEY_V2, REACT_APP_RECAPTCHA_KEY_V3 } = process.env;

const AskQuotation = ({ formFields, showV2, reset, submitText = 'Send', onSubmit }) => {

  const [data, setData] = useState({});

  const handleChange = useCallback((e) => {
    setData(prev => ({
      ...prev,
      ...e
    }))
  }, []);

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${REACT_APP_RECAPTCHA_KEY_V3}`, function () {
      console.log("Script loaded!");
    });
  }, [REACT_APP_RECAPTCHA_KEY_V3]);

  const onRecaptchaChange = useCallback(recaptchaCode => {
    console.log(recaptchaCode);
    setData(prev => ({ ...prev, recaptchaCode: recaptchaCode, recaptchaVersion: 'v2' }));
  }, []);

  const handleOnClick = e => {
    e.preventDefault();
    showV2
      ? onSubmit(data)
      : window.grecaptcha.ready(() => {
        window.grecaptcha.execute(REACT_APP_RECAPTCHA_KEY_V3, { action: 'submit' }).then(token => {
          onSubmit({ ...data, ...{ recaptchaCode: token, recaptchaVersion: 'v3' } });
        });
      });
  }

  useEffect(() => {
    reset && setData({});
  }, [reset])

  return (
    <>
      <form>
        <div className="contact-form-inner">
          {
            formFields.map((field, index) => {
              return (
                <Input
                  field={field}
                  reset={reset}
                  key={`field${index}`}
                  onChange={handleChange} />
              );
            })
          }
          <div className="form-btn-wrapper">
            {showV2 ? <ReCAPTCHA
              sitekey={REACT_APP_RECAPTCHA_KEY_V2}
              onChange={onRecaptchaChange}
            /> : null}
            <div>
              <Button content={submitText} filled={true} onClick={handleOnClick} />
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AskQuotation;
